var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { ReadyToGo, getCMSObject, CantFindConfirmation } from '../../../index';
import isBrowser from '../../utils/isBrowser';
import AwaitAccountConfirmation from '../AwaitAccountConfirmation/AwaitAccountConfirmation';
var queryString = isBrowser() ? window.location.search : '';
var urlParams = new URLSearchParams(queryString);
var queryParams = {
    passcode: urlParams.get('passcode'),
    mode: urlParams.get('mode'),
    registrarId: urlParams.get('registrar_id'),
};
var getPageMode = function (mode) {
    if (mode === 'confirm-email')
        return mode;
    if (mode === 'help-to-verify')
        return mode;
    return 'confirm-email';
};
var AccountConfirm = function (_a) {
    var user = _a.user, actions = _a.actions, cmsSourceFirebase = _a.cmsSourceFirebase, config = _a.config;
    var _b = useState(getPageMode(queryParams.mode)), mode = _b[0], setMode = _b[1];
    var cantFindConfirmationTeleScript = getCMSObject('data.components.teleScripts.cantFindConfirmation.jsonBlock');
    var readyToGoConfirmationTeleScript = getCMSObject('data.components.teleScripts.readyToGoConfirmation.jsonBlock');
    var validateUser = function (params) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (user.verifySuccess) {
                        setMode('success');
                    }
                    if (!(params.passcode || params.registrarId)) return [3 /*break*/, 2];
                    return [4 /*yield*/, actions.userActions.confirm({ passcode: params.passcode, registrar_id: params.registrarId })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    if ((user === null || user === void 0 ? void 0 : user.lastServerResponse) && (user === null || user === void 0 ? void 0 : user.lastServerResponse.type) === 'confirm') {
                        if (user.lastServerResponse.message.code !== '_NOT_FOUND') {
                            setMode('success');
                        }
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        validateUser(queryParams);
    }, [user]);
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'my-4' }), mode === 'confirm-email' && _jsx(AwaitAccountConfirmation, { user: user, config: config, actions: actions, cmsSourceFirebase: cmsSourceFirebase }), mode === 'help-to-verify' && _jsx(CantFindConfirmation, { cmsSourceFirebase: cmsSourceFirebase, telescript: cantFindConfirmationTeleScript }), mode === 'success' && (_jsx(ReadyToGo, { config: config, user: user, actions: actions, telescript: readyToGoConfirmationTeleScript, cmsSourceFirebase: cmsSourceFirebase }))] }));
};
export default AccountConfirm;
